import app from '../store/modules/app';

export default {
  requestInterceptor(config) {
    const token = `Bearer ${app.state._platform_key}`;
    config.headers.Authorization = token;

    return config;
  },
  responseErrorInterceptor(error) {
    if (error.response.status === 401) {
      window.location.href = error.response.data.oauth_url;
    }
    return error;
  },
};
